import * as React from 'react';
import * as styles from './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FlatPlanLayout = function FlatPlanLayout(_ref) {
  var header = _ref.header,
    plan = _ref.plan,
    rightPanel = _ref.rightPanel;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['header'],
      children: header
    }), /*#__PURE__*/_jsx("div", {
      className: styles['right-panel'],
      children: rightPanel
    }), /*#__PURE__*/_jsx("div", {
      className: styles['plan'],
      children: plan
    })]
  });
};